import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../../store';
import LoadingSpinner from '../ui/LoadingSpinner';

const RoleBasedRedirect: React.FC = () => {
  const { isAuthenticated, isLoading, user, token } = useSelector((state: RootState) => state.auth);

  // Show loading if we're fetching data OR if we have auth state but no user yet
  if (isLoading || (isAuthenticated && token && !user)) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900">
        <LoadingSpinner size="large" />
      </div>
    );
  }

  // If not authenticated, stay on public homepage
  if (!isAuthenticated || !user) {
    return <Navigate to="/" replace />;
  }

  // Redirect based on user role
  if (user.role === 'tenant') {
    return <Navigate to="/tenant" replace />;
  } else if (user.role === 'super_admin' || user.role === 'admin') {
    return <Navigate to="/dashboard" replace />;
  }

  // Default fallback (shouldn't happen)
  return <Navigate to="/" replace />;
};

export default RoleBasedRedirect;